import { useEffect, useState } from "react";
import api from "../lib/api";

export default function Terms() {
  const [settings, setSettings] = useState(null);
  useEffect(() => { api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {}); }, []);
  const name = settings?.business_name || "DreamCots";

  const sections = [
    ["1. Acceptance of Terms", `By accessing or using ${name}, you agree to be bound by these Terms and Conditions. If you do not agree, please do not use the platform.`],
    ["2. Accounts & Registration", `Students must verify their mobile number via OTP during registration. Institutes and schools are responsible for the accuracy of the information published on their listing. ${name} may suspend accounts that provide false information.`],
    ["3. Reviews & Points", `Reviews must be genuine and based on real experience. Points are awarded as per the values published on the platform and may be revised by ${name} at any time. Attempting to manipulate rankings through fake reviews, referrals or student entries may result in removal from the directory.`],
    ["4. Listings & Rankings", `Rankings are computed automatically from student reviews, admissions and platform activity. Free listings are limited as displayed in the dashboard. ${name} does not guarantee any specific rank or admission outcome.`],
    ["5. Paid Packages & Payments", `Featured and Verified packages are billed as displayed on the Packages page and processed via our payment partner. Badges remain active for the purchased duration only. Fees are non-refundable except where required by law.`],
    ["6. Content & Conduct", `You may not post unlawful, misleading or offensive content. ${name} may remove any content that violates these terms without prior notice.`],
    ["7. Limitation of Liability", `${name} is a discovery platform. All admissions, fees and services are transacted directly between students and institutions. ${name} is not liable for disputes arising between users and listed institutions.`],
    ["8. Changes to Terms", `${name} may update these Terms and Conditions from time to time. Continued use of the platform constitutes acceptance of the revised terms.`],
    ["9. Contact", `For any questions regarding these terms, reach us through the Contact Us page.`],
  ];

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-14">
      <p className="nb-label" style={{ letterSpacing: "0.2em" }}>Legal</p>
      <h1 data-testid="terms-heading" className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight mt-2">Terms and Conditions</h1>
      <p className="mt-3 text-sm text-slate-500">Last updated: June 2026 · {name}</p>
      <div className="mt-10 space-y-8">
        {sections.map(([title, body]) => (
          <section key={title}>
            <h2 className="font-display text-xl font-extrabold">{title}</h2>
            <p className="text-sm text-slate-600 mt-2 leading-relaxed">{body}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
